export default "__VITE_ASSET__BufgkwTc__"